import { Tabs } from "flowbite-react";
import { FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa6";
import InstagramDiscovery from "./InstagramDiscovery";
import YoutubeDiscovery from "./YoutubeDiscovery";
import TiktokDiscovery from "./TiktokDiscovery";

const Discovery = () => {
  return (
    <Tabs variant="default">
      <Tabs.Item active title="Instagram" icon={FaInstagram}>
        <InstagramDiscovery />
      </Tabs.Item>
      <Tabs.Item title="YouTube" icon={FaYoutube}>
        <YoutubeDiscovery />
      </Tabs.Item>
      <Tabs.Item title="TikTok" icon={FaTiktok}>
        <TiktokDiscovery />
      </Tabs.Item>
    </Tabs>
  );
}

export default Discovery;